export const apiHdrDefValue = {
    APPLICATION_JSON: "application/json",
    REFERRED_BY: "WEB",
    FORM_URLENCODED: "application/x-www-form-urlencoded",
};

export const apiHttpStatus = {
    SC_200: 200,
    SC_201: 201,
    SC_202: 202,
    SC_400: 400,
    SC_403: 403,
    SC_404: 404,
    SC_412: 412,
    SC_424: 424,
    SC_440: 440
};

export const apiDefaultValue = {
    OFFSET: 0,
    LIMIT: 100
};

export const apiAction = {
    YES: "YES",
    NO: "NO"
};

export const apiStatus = {
    REGISTERED: "REGISTERED"
};

export const apiEndPoint = {
    HEALTH: "/health",
    USER: "/user",
    USER_REGISTER: "/users/registration",
    USER_SESSION: "/userSession",
    DEVICE: "/device",
    QUERY: "/query",
    DASHBOARD: "/dashboard",
    DIVISION: "/division",
    GROUP: "/group",
    COMPANY_PREFERENCE: "/companyPreference",
    DEVICE_DATA: "/deviceData",
    FILE: "/file",
    FEEDBACK: "/userFeedback",
    USER_PREFERENCE: "/userPreference",

};

export const apiType = {
    USER: "USER",
    USER_SESSION: "USER_SESSION",
    FEEDBACK: "FEEDBACK",
    REPORT_PROBLEM:"REPORT_PROBLEM"
};

export const apiCategory = {
    USER_PASSWORD: "USER_PASSWORD"
};